
import {serializable, alias, object, list, primitive} from 'serializr';

export class ProductEmission { 

	@serializable(alias('id', primitive()))
	id?: number;

	@serializable(alias('name', primitive()))
	name?: string;

	@serializable(alias('b2c', primitive()))
	b2c?: number;

}